// Chart colours of the Strike AI style template (docs/STRIKE_STYLE.md, section 7).
// A chart drawn on a canvas (Chart.js) cannot read a stylesheet, so it takes
// these in its own options.

// Different things (teams, cost types, series), always in this order: one
// series is navy, two are navy and sky, three add orange, then plum, then
// teal. A sixth thing and beyond is grouped as "Other".
export const SERIES = ['#1d518c', '#3f8fd9', '#d2691e', '#8d5fb3', '#0b8a6f'];
export const SERIES_OTHER = '#a3a3a3';
export const seriesColor = (i) => (i < SERIES.length ? SERIES[i] : SERIES_OTHER);

// One measure, low to high: the navy ramp. Light is low, dark is high.
export const RAMP = ['#dbe7f4', '#b5cde8', '#88aed8', '#5a8cc4', '#346da9', '#1d518c', '#143a66'];

// Below and above a middle (over and under): navy one way, red the other.
export const DIVERGING = ['#1d518c', '#6f93bd', '#b9cbe0', '#ededed', '#efc0c2', '#e07a7f', '#d13138'];

// A status (on time, late) takes the status colours, not the series colours.
export const STATUS = { good: '#15803d', caution: '#a16207', bad: '#d13138', info: '#1d518c', neutral: '#525252' };

// Lettering and grid: ink and grey. Only the marks carry colour.
export const INK = '#0a0a0a';
export const TEXT_SECONDARY = '#525252';
export const MUTED = '#737373';
export const GRID = '#e5e5e5';

// A translucent fill under a line or behind a bar: the colour at the given alpha.
export const alpha = (hex, a) => {
  const n = parseInt(hex.slice(1), 16);
  return `rgba(${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}, ${a})`;
};
